import * as React from 'react';
import { Modal } from '../../../../Modal';
import { TaxDeduction } from "../../../../TaxDeduction";
import * as main from "../../styles/main.module.scss";
import * as cost from "./style.module.scss";
export const Cost = ({ widgetFull, fullText }) => {
  const [showModalFull, setShowModalFull] = React.useState(false);
  return (
    <section className={cost.cost} id="cost">
      <div className="container">
        <h2 className={main.titleH2}>Стоимость кураторского сопровождения</h2>
        <TaxDeduction margin={"0 0 30px"}/>
        <div className={`row ${cost.cost__row}`}>
          <div className={`col-12 col-md-6 ${cost.cost__col}`}>
            <div className={cost.cost__wrapper}>
              <div>
                <p className={cost.cost__priceText}>{ fullText }</p>
                <p><span className={cost.cost__priceColor}>10&nbsp;000&nbsp;₽</span></p>
              </div>
              <div className={`${cost.cost__blockBtn} ${main.blockBtn}`}>
                <button className={`${cost.blue__btn} ${main.mainBtn}`} onClick={()=>{setShowModalFull(true)}}>
                  Оплатить
                </button>
              </div>
            </div>
          </div>
        </div>
        <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/iphone-price.png" alt="" className={cost.cost__bg}/>
      </div>

      <Modal
        open={showModalFull}
        onClose={() => {
          setShowModalFull(false);
        }}
      >
        { widgetFull }
      </Modal>
    </section>
  );
};
